import { IDatiqUnavLink } from './datiq-unav-link.interface';
import { emptyDatiqLink } from './datiq-app.models';
import {
    DATIQ_DEFAULT_EMPTY_LABEL,
    DATIQ_DEFAULT_ID
} from './datiq-app-default-values';

export const emptyDatiqUnavLink: IDatiqUnavLink = {
    id: DATIQ_DEFAULT_ID(),
    label: DATIQ_DEFAULT_EMPTY_LABEL,
    link: { ...emptyDatiqLink },
};
